<div id="st-sub-license-management-stcommonhighpadding" class="st_common_high_padding">
  <div id="st-sub-license-management-block" class="d-flex flex-column gap-3 mb-3 w-100">
    @if (profileLoading.loading() && !user_profile_data) {
    <stupa-skeleton-loader variant="banner" />
    }
    <div id="st-sub-license-management-profile-banner-container" class="profile-banner-container"
      [class.d-none]="profileLoading.loading() && !user_profile_data">
      <button type="button" (click)="navigateToSubLicenses()" (keydown.enter)="navigateToSubLicenses()" (keydown.space)="$event.preventDefault(); navigateToSubLicenses()" id="st-sub-license-management-back-button-container" class="back-button-container tw-w-fit cursor-pointer tw-z-[1]">
        <span class="d-flex align-items-center gap-2">
          <svg
            width="11"
            height="11"
            viewBox="0 0 11 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.56 4.61333V5.94667H2.56L6.22667 9.61333L5.28 10.56L0 5.28L5.28 0L6.22667 0.946667L2.56 4.61333H10.56Z"
              fill="#FFFFFF"
            />
          </svg>

          <p class="fs-15 fw-medium text-white">
            {{ selected_role | translate }}
          </p>
        </span>
      </button>
      <ng-container
        *ngIf="is_image(user_profile_data?.banner); else default_banner_temp"
      >
        <img
          class="profile-banner-image"
          [src]="user_profile_data?.banner"
          alt="Profile Banner"
        />
      </ng-container>
      <ng-template #default_banner_temp>
        <img
          class="profile-banner-image"
          [src]="default_banner"
          alt="Profile Banner"
        />
      </ng-template>

      <div id="st-sub-license-management-profile-details-container" class="profile-details-container">
        <div id="st-sub-license-management-aligible-license-block" class="aligible-license-block">
          <div id="st-sub-license-management-block-1" class="d-flex align-items-center justify-content-between gap-2">
            <div id="st-sub-license-management-block-2" class="d-flex align-items-center gap-2">
              <div id="st-sub-license-management-club-logo-container"
                class="club-logo-container club-logo-config d-flex align-items-center justify-content-center"
              >
                <ng-container
                  *ngIf="is_image(user_profile_data?.logo); else default_logo"
                >
                  <img [src]="user_profile_data?.logo" alt="Logo" />
                </ng-container>
                <ng-template #default_logo>
                  <div id="st-sub-license-management-block-3" class="d-flex align-items-center justify-content-center">
                    <h1 class="fw-bold">
                      {{ getAbbrivation(user_profile_data?.full_name) }}
                    </h1>
                  </div>
                </ng-template>
              </div>
              <div id="st-sub-license-management-club-details-container"
                class="club-details-container d-flex flex-column justify-content-start w-100"
              >
                <p class="fs-20 fw-semibold text-white">
                  {{ user_profile_data?.full_name }}
                </p>
                <p class="fs-15 fw-medium text-white tw-opacity-[.65]">
                  {{ user_profile_data?.display_name }}
                </p>
                <div id="st-sub-license-management-column-group-2" class="d-flex align-items-center column-gap-2 flex-wrap">
                  <div id="st-sub-license-management-block-4"
                    class="d-flex align-items-center gap-2"
                    *ngIf="
                      user_profile_data?.hyperlinks[0]?.link ||
                      user_profile_data?.hyperlinks[0]?.link_name
                    "
                  >
                    <span class="link-svg">
                      <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.38376 2.69551C4.62745 2.81186 4.83965 2.98498 5.00255 3.20035C5.16545 3.41572 5.27429 3.66703 5.31992 3.93318C5.36555 4.19933 5.34665 4.47255 5.26479 4.72988C5.18294 4.98721 5.04052 5.22113 4.84951 5.41201L3.16201 7.09951C2.84554 7.41598 2.41632 7.59377 1.96876 7.59377C1.5212 7.59377 1.09198 7.41598 0.77551 7.09951C0.459041 6.78304 0.28125 6.35382 0.28125 5.90626C0.28125 5.4587 0.459041 5.02948 0.77551 4.71301L1.43439 4.05414M6.44063 3.82089L7.09951 3.16201C7.41598 2.84554 7.59377 2.41632 7.59377 1.96876C7.59377 1.5212 7.41598 1.09198 7.09951 0.77551C6.78304 0.459041 6.35382 0.28125 5.90626 0.28125C5.4587 0.28125 5.02948 0.459041 4.71301 0.77551L3.02551 2.46301C2.8345 2.65389 2.69208 2.88781 2.61023 3.14514C2.52837 3.40247 2.50947 3.67569 2.5551 3.94184C2.60073 4.20799 2.70957 4.45931 2.87247 4.67467C3.03537 4.89004 3.24758 5.06316 3.49126 5.17951"
                          stroke="#939393"
                          stroke-width="0.5625"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <a
                      class="fs-14 fw-medium sch_highlight_score"
                      #link1
                      [href]="user_profile_data?.hyperlinks[0]?.link"
                      target="_blank"
                      >{{ user_profile_data?.hyperlinks[0]?.link_name }}</a
                    >
                  </div>
                  <div id="st-sub-license-management-profile-details-divider"
                    class="profile-details-divider"
                    *ngIf="
                      user_profile_data?.hyperlinks[1]?.link ||
                      user_profile_data?.hyperlinks[1]?.link_name
                    "
                  ></div>
                  <div id="st-sub-license-management-block-5"
                    class="d-flex align-items-center gap-2"
                    *ngIf="
                      user_profile_data?.hyperlinks[1]?.link ||
                      user_profile_data?.hyperlinks[1]?.link_name
                    "
                  >
                    <span class="link-svg">
                      <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.38376 2.69551C4.62745 2.81186 4.83965 2.98498 5.00255 3.20035C5.16545 3.41572 5.27429 3.66703 5.31992 3.93318C5.36555 4.19933 5.34665 4.47255 5.26479 4.72988C5.18294 4.98721 5.04052 5.22113 4.84951 5.41201L3.16201 7.09951C2.84554 7.41598 2.41632 7.59377 1.96876 7.59377C1.5212 7.59377 1.09198 7.41598 0.77551 7.09951C0.459041 6.78304 0.28125 6.35382 0.28125 5.90626C0.28125 5.4587 0.459041 5.02948 0.77551 4.71301L1.43439 4.05414M6.44063 3.82089L7.09951 3.16201C7.41598 2.84554 7.59377 2.41632 7.59377 1.96876C7.59377 1.5212 7.41598 1.09198 7.09951 0.77551C6.78304 0.459041 6.35382 0.28125 5.90626 0.28125C5.4587 0.28125 5.02948 0.459041 4.71301 0.77551L3.02551 2.46301C2.8345 2.65389 2.69208 2.88781 2.61023 3.14514C2.52837 3.40247 2.50947 3.67569 2.5551 3.94184C2.60073 4.20799 2.70957 4.45931 2.87247 4.67467C3.03537 4.89004 3.24758 5.06316 3.49126 5.17951"
                          stroke="#939393"
                          stroke-width="0.5625"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <a
                      class="fs-14 fw-medium sch_highlight_score"
                      [href]="user_profile_data?.hyperlinks[1]?.link"
                      #link2
                      target="_blank"
                      >{{ user_profile_data?.hyperlinks[1]?.link_name }}</a
                    >
                  </div>
                </div>
                <div id="st-sub-license-management-column-group-2-6" class="d-flex align-items-center column-gap-2 flex-wrap">
                  <div id="st-sub-license-management-block-7"
                    class="d-flex align-items-center gap-2"
                    *ngIf="user_profile_data?.phone"
                  >
                    <span class="link-svg">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M1.79457e-06 1.2C1.79457e-06 0.88174 0.12643 0.576516 0.351474 0.351472C0.576517 0.126428 0.881742 1.06432e-07 1.2 1.06432e-07H2.1184C2.39157 -0.0001149 2.65661 0.0929777 2.86971 0.263893C3.08281 0.434809 3.23121 0.673317 3.2904 0.94L3.8632 3.5184C3.92941 3.8169 3.87918 4.12941 3.72277 4.39212C3.56636 4.65483 3.31557 4.84794 3.0216 4.932L2.2752 5.1456C1.9472 5.2392 1.7608 5.5896 1.8912 5.9056C2.35527 7.02753 3.03604 8.04693 3.89455 8.90545C4.75307 9.76396 5.77247 10.4447 6.8944 10.9088C7.2104 11.0392 7.5608 10.8528 7.6544 10.5248L7.868 9.7784C7.95206 9.48443 8.14517 9.23364 8.40788 9.07723C8.6706 8.92082 8.98311 8.87059 9.2816 8.9368L11.86 9.5096C12.1267 9.56879 12.3652 9.71719 12.5361 9.93029C12.707 10.1434 12.8001 10.4084 12.8 10.6816V11.6C12.8 11.9183 12.6736 12.2235 12.4485 12.4485C12.2235 12.6736 11.9183 12.8 11.6 12.8H10.4C9.4808 12.8 8.5896 12.68 7.7392 12.456C5.96405 11.9847 4.34507 11.0524 3.04635 9.75365C1.74763 8.45494 0.815351 6.83595 0.344002 5.0608C0.1151 4.19241 -0.000525388 3.29806 1.79457e-06 2.4V1.2Z"
                          fill="#9F9F9F"
                        />
                      </svg>
                    </span>
                    <p class="fs-14 text-white tw-opacity-[0.6]">
                      {{ user_profile_data?.phone }}
                    </p>
                  </div>
                  <div id="st-sub-license-management-profile-details-divider-8"
                    class="profile-details-divider"
                    *ngIf="user_profile_data?.phone && user_profile_data?.email"
                  ></div>
                  <div id="st-sub-license-management-block-9"
                    class="d-flex align-items-center gap-2"
                    *ngIf="user_profile_data?.email"
                  >
                    <span class="link-svg">
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 13 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11.645 2.72936C10.9437 1.72869 9.97156 0.948846 8.84259 0.481362C9.47537 1.59468 9.92459 2.8027 10.173 4.05896C10.7257 3.68967 11.2216 3.24176 11.645 2.72936ZM9.06179 4.65976C8.79092 2.98978 8.1295 1.40737 7.13139 0.0413623C6.64602 -0.0137874 6.15596 -0.0137874 5.67059 0.0413623C4.67248 1.40737 4.01106 2.98978 3.74019 4.65976C4.58163 5.01737 5.48672 5.20105 6.40099 5.19976C7.34499 5.19976 8.24419 5.00776 9.06179 4.65976ZM3.61219 5.90056C4.5046 6.23189 5.44907 6.40095 6.40099 6.39976C7.38179 6.39976 8.32099 6.22376 9.18979 5.90056C9.23709 6.91116 9.14257 7.92339 8.90899 8.90776C8.08723 9.10253 7.24552 9.20053 6.40099 9.19976C5.53779 9.19976 4.69859 9.09816 3.89379 8.90696C3.66 7.92289 3.56521 6.91093 3.61219 5.90056ZM2.62899 4.05896C2.87749 2.80298 3.32671 1.59524 3.95939 0.482162C2.83043 0.949645 1.85825 1.72949 1.15699 2.73016C1.58019 3.24056 2.07619 3.69016 2.62899 4.05896ZM12.2682 3.83816C12.7204 4.87268 12.8899 6.0087 12.7594 7.13016C11.9776 7.70094 11.1224 8.16377 10.217 8.50616C10.401 7.46637 10.4478 6.40693 10.3562 5.35496C11.067 4.94968 11.7118 4.43818 12.2682 3.83816ZM0.533791 3.83816C1.09016 4.43819 1.73493 4.94969 2.44579 5.35496C2.35508 6.40722 2.40187 7.4668 2.58499 8.50696C1.67958 8.16455 0.82442 7.70172 0.0425916 7.13096C-0.0876668 6.00942 0.0821144 4.87341 0.534592 3.83896L0.533791 3.83816ZM6.40099 10.3998C7.11939 10.3998 7.82339 10.3366 8.50739 10.2158C8.16497 11.1212 7.70214 11.9763 7.13139 12.7582C6.64602 12.8132 6.15597 12.8132 5.67059 12.7582C5.09982 11.9763 4.63699 11.1212 4.29459 10.2158C4.97859 10.3366 5.68259 10.3998 6.40099 10.3998ZM9.88659 9.88536C9.62987 10.7322 9.27972 11.5479 8.84259 12.3174C9.62188 11.9946 10.33 11.5216 10.9264 10.9251C11.5228 10.3287 11.9959 9.62065 12.3186 8.84136C11.5562 9.27496 10.7418 9.62616 9.88659 9.88536ZM3.95939 12.3174C3.18011 11.9946 2.47203 11.5216 1.87561 10.9251C1.27919 10.3287 0.806111 9.62065 0.483392 8.84136C1.24579 9.27496 2.06019 9.62616 2.91539 9.88536C3.17211 10.7322 3.52227 11.5479 3.95939 12.3174Z"
                          fill="#9F9F9F"
                        />
                      </svg>
                    </span>
                    <p class="fs-14 text-white tw-opacity-[0.6]">
                      {{ user_profile_data?.email }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="st-sub-license-management-profile-tabs-container" class="profile-tabs-container position-relative">
      <div id="st-sub-license-management-register-navigator-container" class="d-flex align-items-center gap-2 register-navigator-container">
        <button type="button" (click)="navigateTo('/registration')" (keydown.enter)="navigateTo('/registration')" (keydown.space)="$event.preventDefault(); navigateTo('/registration')" class="fs-14 fw-medium st-primary-lt cursor-pointer">
          {{ "go_to_registration" | translate }}
        </button>
        <div id="st-sub-license-management-profile-details-divider-10" class="profile-details-divider"></div>
        <button type="button" (click)="navigateTo('/order-history')" (keydown.enter)="navigateTo('/order-history')" (keydown.space)="$event.preventDefault(); navigateTo('/order-history')" class="fs-14 fw-medium st-primary-lt cursor-pointer">
          {{ "go_to_registration_history" | translate }}
        </button>
      </div>
      <mat-tab-group id="st-sub-license-management-block-11" (selectedTabChange)="profile_tab_change($event)" [selectedIndex]="tab_index - 1">
        <mat-tab id="st-sub-license-management-suggested-group" class="suggested-group" [label]="profile_tab_list[0].name">
          <ng-template matTabContent>
            <stupa-all-events
              [is_sub_license]="true"
              [user_role_id]="user_role_id"
              (event_tab_index)="updateEventTabIndex($event)"
            ></stupa-all-events>
          </ng-template>
        </mat-tab>
        <mat-tab id="st-sub-license-management-suggested-group-12" class="suggested-group" [label]="profile_tab_list[1].name">
          <ng-template matTabContent>
            <stupa-all-videos
              [is_sub_license]="true"
              [user_role_id]="user_role_id"
            ></stupa-all-videos>
          </ng-template>
          <!-- Videos component will go here -->
        </mat-tab>
        <mat-tab id="st-sub-license-management-suggested-group-13" class="suggested-group" [label]="profile_tab_list[2].name">
          <ng-template matTabContent>
            <stupa-scorecard-list
              [is_sub_license]="true"
              [user_role_id]="user_role_id"
            ></stupa-scorecard-list>
          </ng-template>
          <!-- Live component will go here -->
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
